import { useCallback } from 'react';
import { useRefWithCurrentValue } from './useRefWithCurrentValue';

export function useEventCallback<T extends (...args: Array<any>) => any>(
  handler: T
): T {
  const handlerRef = useRefWithCurrentValue(handler);

  return useCallback(
    (...args: Parameters<T>) => {
      return handlerRef.current(...args);
    },
    [handlerRef]
  ) as T;
}
